export const endpoints = {
  baseURL: process.env.REACT_APP_API_URL ?? "/api/", //Please do not commit changes on this line. It will affect building script and will not work with api on dev and quality.
  auth: {
    Login: "account/Login",
    ChangePassWord: "account/ChangePassword",
    ForgotPassword: "account/ForgotPassword",
    ResetPassword: "account/ResetPassword",
  },
  user:{
   GetOperationalAddress: "account/OperationalAddress",
   UpdateOperationalAddress: "account/UpdateOperationalAddress",
   GetSuggestedStreets: "account/Streets",
   GetPostalCodeByStreet: "account/PostalCodeByStreet",
   UpdatePrintingPreference: "account/UpdatePrintingPreference",
   UpdateOperationalHours: "account/UpdateOperationalHours",
   GetUserPreferences: "account/UserPreferences"
  },
  products: {
    GETALLPRODUCTS: "product/getproductlist",
    ADDNEWPRODUCT: "product/addnewproduct",
    DELETEPRODUCT: "product/deleteproduct",
    UPDATEPRODUCT: "product/updateproduct",
    DUPLICATEPRODUCT: "product/DuplicateProduct",
    UPLOAD_PRODUCTS: "product/UploadBulkProducts",
    UPLOAD_VENDORFORMAT_CSV: "product/UploadVendorFormatCsv",
    DOWNLOAD_CSV: "product/DownloadCSV",
    DOWNLOAD_SAMPLE_CSV: "product/DownloadSampleCSV",
    PRODUCT_META_FIELDS: "product/GetProductMetaFields",
    GetHolidayDays:'product/GetHolidayDays',
    AddHolidayDays:'product/AddHolidayDays',
    DeleteHolidayDays:'product/DeleteHolidayDays',
    UpdateHolidayDays:'product/UpdateHolidayDays',
    ComparisonList:'product/GetComparisonList',
    DownloadComparisonData: 'product/DownloadLiveComparisonData'
  },
  productCategories: {
    GetCategoriesList: "ProductCategory/GetCategoriesList",
    GetFields: "ProductCategory/GetFields",
    GetFieldsByCategoryName: "ProductCategory/GetFieldsByCategoryName",
    UPDATECATEGORY: "ProductCategory/UpdateCategories",
  },
  topDeals:{
    GetComparisonData: "TopDeal/GetComparisonData",
    AcceptProductPrice: "TopDeal/acceptProductPrice",
    UserIntegrations: "TopDeal/UserIntegrations"
  },
  payment: {
    GetPaymentReport: "order/getPaymentsReport",
    GetPaymentReportCondensed: "order/getPaymentsReportCondensed",
    DownloadPaymentReport: "order/downloadPaymentsReport",

  },

  campaign: {
    ADDCAMPAIGN: "TopDeal/AddCampaign",
    GETCAMPAIGN: "product/getCampaign",
    UPDATECAMPAIGN: "TopDeal/EndCampaign",
  },
  admin: {
    GETUSERS: "product/GetUsers",
    VIEWASUSER: "product/ViewAsUser",
    UPDATEUSER: "account/UpdateUser",
    REGISTER: "account/V2/Register",
  },
    summary: {
      GETSUMMARY: "order/GetSummary",
      AddReply:"reviews/AddReply",
      GetVendorReviews:"reviews/GetVendorReview",
  },
  productModels: {
    GetProductModelList: "ProductModel/GetModelList",
  },
  productWeights: {
    GetProductWeightList: "ProductWeight/GetWeightList",
  },
  productGrades: {
    GetProductGradeList: "ProductGrade/GetGradeList",
  },
  productDescription: {
    GetProductDescription: "ProductDescription/GetProductDescription",
  },
  order: {
    ToggleAutoAcceptOrder: "Order/ToggleAutoAcceptOrder",
    PayMiscVendor:'Order/PayMiscVendor',
    PayVendor:'Order/PayVendor',
    ViewVendorMisc:'Order/ViewVendorMisc',
  },
  SportsShopOnBoarding:{
    SendOtp:"account/SendOtpToSportsShop",
    VerifyOtp:"account/ValidateOtp",
    Register:"account/RegisterSportsShop"
  },
  WooCommerce:{
    AuthLink:"WooCommerce/GenerateAuthLink",
    UploadStatus:"WooCommerce/GetUploadStatus",
    UpdatePricePreference:"WooCommerce/UpdatePriceSyncStatus",
    UpdateCategoryMap:"WooCommerce/UpdateCategoryMapping"
  },

  Shopify:{
    AppLink:"Shopify/GenerateAppLink",
    UploadStatus:"Shopify/GetUploadStatus",
    UpdatePricePreference:"Shopify/UpdatePriceSyncStatus",
    UpdateCategoryMap:"Shopify/UpdateCategoryMapping",
    UpdateProductMap:"Shopify/UpdateProductMapping"

  }
};
